import React from "react";
import { HABIT_ICON_OPTIONS } from "../constants/icons";

export function HabitIcon({ h, size = 18, style = {}, color }) {
  const col = color || h?.color || "#d4789a";
  if (h?.phosphorIcon) {
    const match = HABIT_ICON_OPTIONS.find(o => o.key === h.phosphorIcon);
    if (match) {
      const { C: Icon } = match;
      return <Icon size={size} weight="duotone" color={col} style={{ flexShrink: 0, ...style }} />;
    }
  }
  return <span style={{ fontSize: size * 0.8, lineHeight: 1, ...style }}>{h?.emoji || "⭐"}</span>;
}
